import { Serializable } from '../../../../core/models/serializable';
import { RangeFilter } from '../../../../shared/models/range.model';
import { InvoiceStatus } from '../models/invoice-status';

export class InvoiceListFilterModel
  implements Serializable<InvoiceListFilterModel>
{
  fromObject(object: any): InvoiceListFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    return {
      TransactionCode: this.transactionCode,
      InvoiceCode: this.invoiceCode,
      InvoiceStatus: this.invoiceStatus,
      CustomerCredential: this.customerCredential,
      AccountManagerId: this.accountManagerId,
      CreateDate: this.createDate,
      ActivationDate: this.activationDate,
      Mismatched: this.mismatched,
    };
  }

  public transactionCode: string;
  public invoiceCode: string;
  public invoiceStatus: InvoiceStatus;
  public customerCredential: string;
  public accountManagerId: number;
  public createDate: RangeFilter<Date>;
  public activationDate: RangeFilter<Date>;
  public mismatched: boolean;

  constructor(dayCount: number) {
    if (dayCount != null) {
      let now = new Date();
      let from = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() - dayCount
      );
      this.activationDate = new RangeFilter<Date>(from, null);
    }
  }
}
